import React, { Component, useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { changePage, getItemList, defaultStoreItemList, selectedFood, setTotalOrderPrice } from '../../../../action/hcommerce'
import { closeOrderPopUp } from '../../../action/hCommerce2'
import { popupOpenClose, setConformPage } from '../../../../action/action'
import { contScrollToBottom, hideScrolltoBottomHandler } from '../../../JS/scroll';
import { CMSPath } from '../../../../config/constant'
import { withTranslation } from "react-i18next";
import { sendAnalytics } from '../../../../action/homeAction';
import { getCleanUrl, getDefaultAnalyticsLabel } from '../../../JS/utility';


const AddOnPopupWithGrouping = (props) => {

    const { t } = props;
    let selectedAddOn = false;
    const [imagePathLarge, setImagePathLarge] = useState("")
    const [itemAddOnsInfoGroup, setItemAddOnsInfoGroup] = useState([]);
    const [onlyOptionalAddOns, setOnlyOptionalAddOns] = useState(false);
    const [localSelectedAddon, setLocalSelectedAddon] = useState([...props.addOn]);
    const [closeAddOns, setCloseAddOns] = useState([]);
    const activeSubTypeId = (props.selectedSubItemStoreLevel2 && props.selectedSubItemStoreLevel2.id) || (props.SelectedSubItem && props.SelectedSubItem.id);


 

    const handleAddOnDrawer = (id) => {
        const updatedAddOnDrawer = closeAddOns.includes(id)
            ? closeAddOns.filter((addOnGrouopId) => addOnGrouopId !== id)
            : [...closeAddOns, id];

            setCloseAddOns(updatedAddOnDrawer);
    }

    const sortAddOnHandler = (addOns) => {

        let sortedArr = [];

        if (!addOns || addOns.length === 0) {
            return;
        }

        sortedArr = [...addOns]
        sortedArr.sort((a, b) => a.priority > b.priority ? 1 : -1)
        return sortedArr;
    }

    const addToMyBag = () => {

        let copyLocalSelectedAddon = localSelectedAddon;

        // check if default addOns are added else add them making quantity -1
        itemAddOnsInfoGroup.forEach((group) => {
            if(group.groupType == "DEFAULT_ADD_ON"){
                group.itemAddOnsInfo.forEach(defaultAddon => {
                    if (!copyLocalSelectedAddon.some(selectedAddon => selectedAddon.id === defaultAddon.id)) {
                        defaultAddon.quantity = -1; // Set quantity to -1
                        copyLocalSelectedAddon.push(defaultAddon); // Add to selected addons
                    }
                });
            }
        })

        // sorting addons to correct price as per "included" key. As next addon price should be added to order total after we reach "included" value
        let sortedLocalSelectedAddon = copyLocalSelectedAddon.sort((a, b) => a.id - b.id);
        const selectedGroups = {};

        // making group of addOns.
        sortedLocalSelectedAddon.forEach(addon => {
            if (!selectedGroups[addon.storeGroupId]) {
                selectedGroups[addon.storeGroupId] = [];
            }
            selectedGroups[addon.storeGroupId].push(addon);
        });


        for (const group of itemAddOnsInfoGroup) {
            const selectedGroup = selectedGroups[group.id] || [];

            // checking if min quantity of addon selected.
            if (selectedGroup.length < group.min) {
                props.closeOrderPopUp(true, `Min ${group.min} addons should be selected for ${group.groupName}`, "", true);
                return;
            }

            // "included" addon check, once we react limit we have to add price of the addons in order total.
            if (selectedGroup) {
                let included = group.included || 0;
                selectedGroup.forEach(addon => {
                    addon.actualPrice = addon.price;
                    if(addon.quantity > 0 && included > 0){
                        addon.price = 0;
                        included--;
                    }
                });
            }
        }

        // converting back to array.
        const finalDataArray = [].concat(...Object.values(selectedGroups));

        props.addOnCheckBoxCLick(finalDataArray, () => {
            props.addToMyOrder();
        })

    }

    const addOnCheckBoxCLickFunction = (addOn) => {

        setLocalSelectedAddon(prevSelectedAddons => {
            const updatedSelectedAddOns = [...prevSelectedAddons];
            const groupCounts = {};
            
            for (const item of updatedSelectedAddOns) {
                groupCounts[item.storeGroupId] = (groupCounts[item.storeGroupId] || 0) + 1;
            }
    
            const addonGroupInfo = itemAddOnsInfoGroup.find(groupInfo => groupInfo.id == addOn.storeGroupId);
    
            const existingIndex = updatedSelectedAddOns.findIndex(item => item.id === addOn.id);
            if (existingIndex !== -1) {
                // Remove the add-on
                updatedSelectedAddOns.splice(existingIndex, 1);
            } else {

                if (addonGroupInfo) {
                    const totalSelected = groupCounts[addonGroupInfo.id] || 0;
        
                    if (totalSelected >= addonGroupInfo.max) {
                        props.closeOrderPopUp(true, `Max ${addonGroupInfo.max} addons can be selected for ${addonGroupInfo.groupName}`, "", true);
                        return updatedSelectedAddOns; // No change
                    }
                }

                // Add the add-on
                updatedSelectedAddOns.push({...{...addOn, quantity: 1}, quantity: 1});
            }

            return updatedSelectedAddOns;
        });
    };

    useEffect(() => {
        const sortedAddOns = sortAddOnHandler(props.itemAddOnsInfo) || [];

        const updatedItemAddOnsInfoGroup = sortedAddOns.reduce((accumulator, addOnItem) => {
            if (addOnItem.storeItemId === props.SelectedFood.id) {

                const relevantGroup = props.storeItemAddOnGroupInfo.find(group => {
                    const matchingType = props.addOnGroupTypeItemAddonInfo.find(type => type.itemAddonId === addOnItem.id);
                    if (!matchingType || group.id !== matchingType.storeItemAddonGroupTypeId) {
                        return false;
                    }
                    // only match groups configured for the active subtype.
                    if (Array.isArray(group.storeItemSubTypeId) && group.storeItemSubTypeId.length > 0 && activeSubTypeId) {
                        return group.storeItemSubTypeId.some((id) => Number(id) === Number(activeSubTypeId));
                    }

                    return true;
                });

                if (relevantGroup) {
                    const existingGroup = { ...props.addOnGroupTypeInfo.find(type => type.id === relevantGroup.groupId) };
                    const existingGroupIndex = accumulator.findIndex(group => group.id === relevantGroup.id);

                    const updatedAddOnItem = { ...addOnItem, addOnGroupId: relevantGroup.groupId, addOnGroupType: existingGroup.groupType,  storeGroupId: relevantGroup.id };

                    if (existingGroup.groupType == "DEFAULT_ADD_ON") {
                        addOnCheckBoxCLickFunction(updatedAddOnItem);
                    }

                    if (existingGroupIndex !== -1) {
                        accumulator[existingGroupIndex].itemAddOnsInfo.push(updatedAddOnItem);
                    } else {
                        accumulator.push({ ...existingGroup, ...relevantGroup, itemAddOnsInfo: [updatedAddOnItem] });
                    }
                }
            }

            return accumulator;
        }, []);


        if (updatedItemAddOnsInfoGroup) {
            const checkIfAllOptionalGroup = updatedItemAddOnsInfoGroup.every(
                (addOnsGroupInfo) => addOnsGroupInfo.groupType === "OPTIONAL_ADD_ON"
            );
            
            if (checkIfAllOptionalGroup) {
                setOnlyOptionalAddOns(true);
            }
        }


        setItemAddOnsInfoGroup(updatedItemAddOnsInfoGroup);
    }, [props.itemAddOnsInfo, props.addOnGroupTypeItemAddonInfo, props.storeItemAddOnGroupInfo, props.addOnGroupTypeInfo, props.SelectedFood.id, activeSubTypeId]);


    useEffect(() => {
        if (props.SelectedFood.storeItemImages.length === 1) {
            setImagePathLarge(getCleanUrl(`${props.SelectedFood.storeItemImages[0].imagePath}`))
        } else {
            props.SelectedFood.storeItemImages.map((images) => {
                if (images.imageType === "LARGE") {
                    setImagePathLarge(encodeURI(getCleanUrl(`${images.imagePath}`)))
                }
            })
        }
    },[])

    useEffect(() => {
        console.log("Addon Grouping Below: ")
        console.log(itemAddOnsInfoGroup)
    }, [itemAddOnsInfoGroup])


    useEffect(() => {
        console.log("Selected Addons: ")
        console.log(localSelectedAddon)
    }, [localSelectedAddon])

    return (
        <>
            <section class="widgets detail-item add-on-with-grouping">
                <div class="widgets">
                    <div class="row">

                        <div class="row">
                            <div class="col col-2">
                                <div class="details-header" style={{ background: `url(${imagePathLarge})` }}></div>
                                <div class="detail-body">
                                    <h4>
                                        <span class="item-name" dangerouslySetInnerHTML={{ __html: props.SelectedFood.itemName }}></span>
                                        <span class="item-price" dangerouslySetInnerHTML={{ __html: `<span style ="font-size:1rem">${props.currencyCode}</span> ${props.SelectedFood.itemPrice}` }}></span>
                                    </h4>

                                    <div class="item-desc" dangerouslySetInnerHTML={{ __html: props.SelectedFood.itemDescription }}>
                                    </div>

                                    <div class="item-add margin-top-1">
                                        {!props.storeInfo.disableAddRemoveItemsButtons &&
                                            <button class="button w-100"
                                                onClick={() => addToMyBag()}
                                                disabled={!onlyOptionalAddOns && localSelectedAddon.length === 0}>{t('hcommerce.addon_popup.add_to_myorder')}</button>}

                                        <button class="button w-100 margin-top-1 secondary" onClick={props.backBtn}>{t('hcommerce.addon_popup.close')}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="form-row">
                                    {
                                        itemAddOnsInfoGroup.map((groupInfo) => {
                                            return (
                                                <div class={`drawer ${!closeAddOns.includes(groupInfo.id) && "open"}`}>
                                                    <div class="drawer-header" onClick={() => handleAddOnDrawer(groupInfo.id)}>
                                                        <div class="drawer-icons">
                                                            <span class="fa fa-chevron-down"></span>
                                                            <span class="fa fa-chevron-up"></span>
                                                        </div>
                                                        <label>{groupInfo.groupName}</label>
                                                    </div>

                                                    <div class="drawer-description">
                                                        <p>{groupInfo.descriptionText}</p>
                                                    </div>

                                                    { !closeAddOns.includes(groupInfo.id) &&
                                                        groupInfo.itemAddOnsInfo.map((iterator) => {

                                                            let imagePathAddOns = null;
                                                            imagePathAddOns = iterator.largeImage && getCleanUrl(encodeURI(`${iterator.largeImage}`))

                                                            return (
                                                                <div class="drawer-body">
                                                                    <div class="drawer-item">
                                                                        <div class="drawer-item-img">
                                                                            {imagePathAddOns && <img src={imagePathAddOns} />}
                                                                        </div>
                                                                        <div class="drawer-item-name">
                                                                            <p><strong dangerouslySetInnerHTML={{ __html: `${iterator.name}` }}></strong></p>
                                                                            <p dangerouslySetInnerHTML={{ __html: `${props.currencyCode} ${iterator.price}` }}></p>
                                                                        </div>
                                                                        {
                                                                            !props.storeInfo.disableAddRemoveItemsButtons && localSelectedAddon.map((iter, index) => {
                                                                                if (iter.id === iterator.id) {
                                                                                    selectedAddOn = true
                                                                                    return (<div class="overlay-tile-input" >
                                                                                        <input type="checkbox" checked={true}
                                                                                            onClick={() => addOnCheckBoxCLickFunction(iterator)}
                                                                                        // disabled = {state.noSelection}
                                                                                        />
                                                                                    </div>
                                                                                    )
                                                                                }
                                                                            })
                                                                        }
                                                                        {
                                                                            !selectedAddOn && !props.storeInfo.disableAddRemoveItemsButtons ? <div class="overlay-tile-input">
                                                                                <input type="checkbox" checked={false}
                                                                                    onClick={() => addOnCheckBoxCLickFunction(iterator)}
                                                                                // disabled = {state.noSelection}
                                                                                />
                                                                            </div> : selectedAddOn = false
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )

}



const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        SelectedFood: state.store.Hcommerce.SelectedFood,
        SelectedNavComponent: state.store.Hcommerce.SelectedNavComponent,
        upsellItem: state.store.Hcommerce.upsellItem,
        myOrders: state.store.Hcommerce.myOrders,
        storeInfo: state.store.Hcommerce.storeInfo,
        menuColor: state.store.home.MenuColor,
        itemAddOnsInfo: state.store.Hcommerce.itemAddOnsInfo,
        addOnGroupTypeItemAddonInfo: state.store.Hcommerce.addOnGroupTypeItemAddonInfo,
        storeItemAddOnGroupInfo: state.store.Hcommerce.storeItemAddOnGroupInfo,
        addOnGroupTypeInfo: state.store.Hcommerce.addOnGroupTypeInfo,
        SelectedSubItem: state.store.Hcommerce.SelectedSubItem,
        selectedSubItemStoreLevel2: state.store.Hcommerce.selectedSubItemStoreLevel2,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
    }
}

export default connect(mapStateToProps, {
    changePage,
    popupOpenClose,
    setConformPage,
    selectedFood,
    setTotalOrderPrice,
    closeOrderPopUp,
    sendAnalytics
})(withTranslation('translations')(AddOnPopupWithGrouping));
